import React from 'react'
import { massCheck } from '../timesheetUtils'

const UnbilledTab = ({familiesNotBilled, getFamilyData, teachers}) => {

    const generateCleanListOfTeachers = (students) => {
        let myHash = {}
        let myArrayOfNames = []
        students.forEach(stu => teachers.forEach((teach) => teach.TeacherID === stu.teachersId && (!myHash[teach.Name] && (myHash[teach.Name] = true, myArrayOfNames.push(teach.Name)))));
        return myArrayOfNames
    }

    return(
        <div>
        <table className="student-table">
            <thead>
                <tr>
                    <th><input onClick={(e) => massCheck(e.target.checked)} type="checkbox" /></th>
                    <th>Family Name</th>
                    <th>Email</th>
                    <th>Students</th>
                    <th>School</th>
                    <th>Teachers</th>
                </tr>
            </thead>
            <tbody>
                {familiesNotBilled.map(family => (
                    <tr key={family.familyId} className="each-row">
                        <td><input className={"student-checkbox"} type="checkbox" value={family.primaryEmail}/></td>
                        <td onClick={() => getFamilyData(family.familyId)}>{family.familyName}</td>
                        <td onClick={() => getFamilyData(family.familyId)}>{family.primaryEmail}</td>
                        <td onClick={() => getFamilyData(family.familyId)}>{family.students.length}</td>
                        <td onClick={() => getFamilyData(family.familyId)}>{family.school}</td>
                        <td onClick={() => getFamilyData(family.familyId)}>{generateCleanListOfTeachers(family.students).map(teacher => <div key={teacher}><p>{teacher}</p></div>)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
    )
}
export default UnbilledTab